import { render, staticRenderFns } from "./FormConfiguracion.vue?vue&type=template&id=56d8678c&"
import script from "./FormConfiguracion.vue?vue&type=script&lang=js&"
export * from "./FormConfiguracion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports